<template>
  <div>
    <el-radio-group
      ref="radio"
      v-model="v_value"
      :size="size"
      :disabled="disabled"
      @change="change"
    >
      <component
        :is="button ? 'el-radio-button' : 'el-radio'"
        v-for="option in optionData"
        :key="option.value"
        :label="option.value"
      >
        {{ option.label }}
      </component>
    </el-radio-group>
  </div>
</template>

<script>
import { request } from '@/api/service'
import { cloneDeep } from 'lodash'

export default {
  name: 'DictRadioGroup',
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: '',
    }, // 标准 v-model
    checkValue: {
      type: [String, Number, Boolean, Object],
      default: '',
    }, // 保持与 dict-check-box 接口风格一致
    size: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    button: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '/master/common/dict/system',
    },
    body: {
      type: Object,
      default: () => {},
    },
    params: {
      type: Object,
      default: () => {},
    },
    method: {
      type: String,
      default: 'POST',
    },
    options: {
      type: Object,
      default: () => ({ label: 'label', value: 'value' }),
    },
    cache: {
      type: Boolean,
      default: true,
    },
    itemsTransform: {
      type: Function,
    },
  },
  data() {
    return {
      v_value: '',
      label: '',
      item: null,
      valueString: '',
      labelString: '',
      optionData: [],
    }
  },
  computed: {
    optionsMap() {
      return Object.fromEntries(this.optionData.map((o) => [o.value, o]))
    },
    reuqestParams() {
      return {
        body: this.body,
        params: this.params,
        url: this.url,
      }
    },
    innerValue() {
      const propsData = this.$options.propsData || {}
      if (Object.prototype.hasOwnProperty.call(propsData, 'checkValue')) {
        return this.checkValue
      }
      return this.value
    },
  },
  watch: {
    reuqestParams: {
      deep: true,
      handler() {
        this.init()
      },
    },
    innerValue: {
      immediate: true,
      handler(val) {
        this.v_value = cloneDeep(val)
      },
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      if (!this.url) return

      const data = await request({
        url: this.url,
        method: this.method,
        data: this.body,
        params: this.params,
        cache: this.cache,
      })
        .then((res) => res.body?.data || [])
        .catch(() => [])

      const _items = this._dataTransform(data)
      this.optionData = this.itemsTransform
        ? this.itemsTransform(_items)
        : _items

      this.$emit('loaded', data)
    },
    change(val) {
      const _item = this.optionsMap[val] || null
      const _label = _item?.label || ''
      const _valueString = [null, undefined].includes(val) ? '' : String(val)

      this.$emit('input', val)
      this.$emit('update:checkValue', val)
      this.$emit('change', val, _label, {
        item: _item,
        value: val,
        label: _label,
        valueString: _valueString,
        labelString: _label,
      })

      this.item = _item
      this.label = _label
      this.valueString = _valueString
      this.labelString = _label
    },
    _dataTransform(data) {
      if (!this.options) return data
      if (!data.length) return []

      return data.map((t) => {
        const { label, value } = this.options
        return {
          label: t[label || 'label'],
          value: value === 'this' ? t : t[value],
        }
      })
    },
  },
}
</script>
